import { render, staticRenderFns } from "./Notifi.vue?vue&type=template&id=92bae94a&scoped=true"
import script from "./Notifi.vue?vue&type=script&lang=js"
export * from "./Notifi.vue?vue&type=script&lang=js"
import style0 from "./Notifi.vue?vue&type=style&index=0&id=92bae94a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bae94a",
  null
  
)

export default component.exports